import React, { useEffect, useState } from 'react'
import GitHubCalendar from 'react-github-calendar'

const lightTheme = {
  level0: '#ede8ff',
  level1: '#d4c5f0',
  level2: '#a78bda',
  level3: '#7c5cbf',
  level4: '#4a3580',
}

const darkTheme = {
  level0: '#2a2650',
  level1: '#4a3580',
  level2: '#7c5cbf',
  level3: '#a78bda',
  level4: '#d4c5f0',
}

function useIsDark() {
  const read = () => document.documentElement.getAttribute('data-theme') === 'dark'
  const [dark, setDark] = useState(read)
  useEffect(() => {
    const mo = new MutationObserver(() => setDark(read()))
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['data-theme'] })
    return () => mo.disconnect()
  }, [])
  return dark
}

function Github() {
  const dark = useIsDark()
  const colourTheme = dark ? darkTheme : lightTheme

  return (
    <div style={{ paddingTop: '20px' }}>
      <div className="section-tag" style={{ textAlign: 'center', marginBottom: '12px' }}>contributions</div>
      <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '32px' }}>
        Days I <span>Code</span>
      </h2>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <GitHubCalendar
          username="Amaan-AeonX"
          blockSize={14}
          blockMargin={5}
          fontSize={14}
          theme={colourTheme}
          colorScheme={dark ? 'dark' : 'light'}
        />
      </div>
    </div>
  )
}

export default Github
